import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import SecurityIcon from "@mui/icons-material/Security";
import GroupsIcon from "@mui/icons-material/Groups";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Icon } from "../styledConstants";
import IconDashboard from "../../assets/images/IconDashboard";
// import IconMerchant from "../../assets/images/IconMerchant";
import IconAddUser from "../../assets/images/IconAddUser";
import IconBusiness from "../../assets/images/IconBusiness";
import IconSettings from "../../assets/images/IconSettings";
import IconSendNotification from "../../assets/images/IconSendNotification";
import IconReport from "../../assets/images/IconReport";
// import IconTicket from "../../assets/images/IconTicket";
import IconOverview from "../../assets/images/overview-icon.png";
import IconMerchant from "../../assets/images/merchant-icon.png";
import IconAddAdmin from "../../assets/images/add-icon.png";
import IconUser from "../../assets/images/user-icon.png";
import IconManage from "../../assets/images/manage-icon.png";
import IconSetting from "../../assets/images/setting-icon.png";
import IconLiveReport from "../../assets/images/livereport-icon.png";
import IconGenerateReport from "../../assets/images/generatereport-icon.png";
import IconSend from "../../assets/images/send-icon.png";
import IconTicket from "../../assets/images/ticket-icon.png";
import IconCard from "../../assets/images/card-icon.png";
import IconHelp from "../../assets/images/help-icon.png";
import IconOperator from "../../assets/images/operator-icon.png";
import IconQr from "../../assets/images/qr-icon.png";
import IconPayBack from "../../assets/images/manage_payback.png";
import IconLoginJostory from "../../assets/images/login_history.png";
import IconChnagePaas from "../../assets/images/changed_Password.png";
import { PERMISSIONS } from "../../utils/Permissions";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import InventoryIcon from "@mui/icons-material/Inventory";
// 0: "merchant profile"
// 1: "dashboard"
// 2: "individual merchant"
// 3: "business merchant"
// 4: "search-permission"
// 5: "all-permission"

export const navData = [
  {
    icon: <HomeIcon style={{ fontSize: 21 }} />,
    link: "/welcome",
    title: "Home",
    id: "HOME",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    alwaysShow: true,
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconOverview} width="21px" alt="overview" />,
    link: "/dashboard",
    title: "Overview",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.OVERVIEW],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconMerchant} width="21px" alt="merchant" />,
    link: "/merchant-profile",
    title: "User",
    id: "MERCHANT_PROFILE",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT,
      PERMISSIONS.MERCHANT_BUSINESS_MERCHANT,
      PERMISSIONS.MERCHANT_MIN_KYC_USER,
      PERMISSIONS.MERCHANT_NCMC_USER,
      PERMISSIONS.MERCHANT_FOS_USER,
    ],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/merchant/individual/list",
        title: "Individual User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT],
      },
      {
        icon: "",
        link: "/merchant/business/list",
        title: "Business User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
      {
        icon: "",
        link: "/merchant/basic_user/list",
        title: "Min Kyc User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_MIN_KYC_USER],
      },
      {
        icon: "",
        link: "/merchant/ncmc_user/list",
        title: "NCMC User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_NCMC_USER],
      },
      {
        icon: "",
        link: "/merchant/fos_user/list",
        title: "FOS User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_FOS_USER],
      },
    ],
  },
  {
    icon: <Icon src={IconAddAdmin} width="21px" alt="add" />,
    link: "/manage-admin",
    title: "Manage Admin",
    id: "CREATE_USER",
    role: ["ROLE_MERCHANT_ADMIN"],
    permissions: [PERMISSIONS.ADMIN_ADD, PERMISSIONS.ADMIN_VIEW],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/admin-register",
        title: "Add Admin",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.ADMIN_ADD],
      },
      {
        icon: "",
        link: "/admin-list",
        title: "View Admin",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.ADMIN_VIEW],
      },
    ],
  },
  {
    icon: <Icon src={IconOperator} width="21px" alt="operator" />,
    link: "/manage-distributor",
    title: "Manage Distributor",
    id: "CREATE_USER",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_ADD, PERMISSIONS.MANAGE_DISTRIBUTOR_VIEW],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/distributor-register",
        title: "Add Distributor",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_ADD],
      },
      {
        icon: "",
        link: "/distributor-list",
        title: "View Distributor",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_VIEW],
      },
    ],
  },

  {
    icon: <Icon src={IconMerchant} width="21px" alt="overview" />,
    link: "/partner",
    title: "Partner",
    id: "PARTNER",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/society-partner",
        title: "Society Partner",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
      },
      {
        icon: "",
        link: "/program-manager",
        title: " Add Program Manager",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
      },
      {
        icon: "",
        link: "/tid-whitelisting",
        title: "TID Whitelisting",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.TID_WHITELISTING],
      },
    ],
  },

  {
    icon: <Icon src={IconManage} width="21px" alt="manage" />,
    link: "/mcc",
    title: "Manage MCC",
    id: "MCC",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/new-mcc",
        title: "Add New MCC",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
      {
        icon: "",
        link: "/view-mcc-list",
        title: "View MCC Lst",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
    ],
  },

  {
    icon: <Icon src={IconSetting} width="21px" alt="setting" />,
    link: "/payment-settings",
    title: "Payment Settings",
    id: "ADD_CONFIG",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.PAYMENT_SETTING_ADD_NEW,
      PERMISSIONS.PAYMENT_SETTING_LIST,
      PERMISSIONS.PAYMENT_SETTING_DEFAULT,
      PERMISSIONS.PAYMENT_SETTING_MCC_CONFIGURATION,
      PERMISSIONS.PAYMENT_SETTING_CASHBACK_CONFIGURATION,
    ],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/payment-settings/add",
        title: "Add New",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_ADD_NEW],
      },
      {
        icon: "",
        link: "/payment-settings/list",
        title: "List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_LIST],
      },
      {
        icon: "",
        link: "/payment-settings/default",
        title: "Default",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_DEFAULT],
      },
      {
        icon: "",
        link: "/payment-settings/mcc",
        title: "MCC Configuration",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_MCC_CONFIGURATION],
      },
        {
        icon: "",
        link: "/payment-settings/cashback",
        title: "Cashback Configuration",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_CASHBACK_CONFIGURATION],
      },
    ],
  },
  {
    icon: <Icon src={IconManage} width="21px" alt="manage" />,
    link: "/manage-permission",
    title: "Manage Permission",
    id: "UPDATE_PERMISSION",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_PERMISSION],
    active: true,
    expanded: false,
  },
  {
    icon: <Icon src={IconCard} width="21px" alt="card" />,
    link: "/manage-card",
    title: "Manage Card",
    id: "PREPAID_CARD_VIEW",
    expanded: false,
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_CARD_ASSIGN_CARD,
      PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD,
      PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD,
      PERMISSIONS.MANAGE_CARD_ORDER_LIST,
    ],
    active: true,
    subNav: [
      {
        icon: "",
        link: "/manage-card/list",
        title: "Assign Cards",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_ASSIGN_CARD],
      },
      {
        icon: "",
        link: "/manage-card/physical-card",
        title: "Manage Physical Card",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD],
      },
      {
        icon: "",
        link: "/manage-card/virtual-card",
        title: "Manage Virtual Card",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD],
      },
      {
        icon: "",
        link: "/manage-card/orders",
        title: "Manage Order List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_ORDER_LIST],
      },
    ],
  },
  {
    icon: <Icon src={IconManage} width="21px" alt="manage" />,
    link: "/manage-soundbox/orders",
    title: "Manage SoundBox Order",
    id: "SOUNDBOX_ORDER",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_SOUNDBOX_ORDER],
    active: true,
    expanded: false,
  },
  {
    icon: <Icon src={IconSend} width="21px" alt="notification" />,
    link: "/transactions",
    title: "Transactions",
    id: "TRANSACTION_LISTING",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TRANSACTION_PAYMENT, PERMISSIONS.TRANSACTION_SETTLEMENT],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconSend} width="21px" alt="notification" />,
    link: "/transaction-charges",
    title: "Transaction Charges",
    id: "TRANSACTION_CHARGES",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TRANSACTION_CHARGES],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconUser} width="21px" alt="user" />,
    link: "/",
    title: "View User List",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.VIEW_USER_LIST],
    expanded: false,
    active: false,
  },

  {
    icon: <Icon src={IconLiveReport} width="21px" alt="report" />,
    link: "/reports",
    title: "Manage Reports",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_REPORT,
      PERMISSIONS.MANAGE_REPORT_BY_TRANSACTIONS,
      PERMISSIONS.MANAGE_DAILY_REPORT,
      PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT,
      PERMISSIONS.MANAGE_MAIN_REPORT,
      PERMISSIONS.MANAGE_APPROVE_EMAIL_REPORTS,
      PERMISSIONS.MANAGE_ORG_SETTLEMENT_REPORTS,
      PERMISSIONS.MANAGE_ORG_TRANSACTION_REPORTS,
      PERMISSIONS.MANAGE_UPI_REPORTS,
      PERMISSIONS.MANAGE_OFFLINE_TRANSACTION_REPORT
    ],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/reports",
        title: "Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      {
        icon: "",
        link: "/reports-by-transaction",
        title: "Reports By Transaction",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT_BY_TRANSACTIONS],
      },
      {
        icon: "",
        link: "/daily-reports",
        title: "Daily Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DAILY_REPORT],
      },
      {
        icon: "",
        link: "/hold_balance_reports",
        title: "Hold Balance Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT],
      },
      {
        icon: "",
        link: "/org_hold_balance_reports",
        title: "Org Hold Balance Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT],
      },
      {
        icon: "",
        link: "/main_reports",
        title: "Main Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_MAIN_REPORT],
      },
      {
        icon: "",
        link: "/email_reports",
        title: "Approve Email Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_APPROVE_EMAIL_REPORTS],
      },
      {
        icon: "",
        link: "/org_settelement_reports",
        title: "ORG Settlement Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_ORG_SETTLEMENT_REPORTS],
      },
      {
        icon: "",
        link: "/org_transaction_reports",
        title: "ORG Transaction Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_ORG_TRANSACTION_REPORTS],
      },
      {
      icon: "",
      link: "/offline_report",
      title: "Offline Transaction Report",
      role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      permissions: [PERMISSIONS.MANAGE_OFFLINE_TRANSACTION_REPORT],
    },
      {
        icon: "",
        link: "/upi_reports",
        title: "Upi Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_UPI_REPORTS],
      },
      {
        icon: "",
        link: "/settlement_reports",
        title: "Settlement Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      {
        icon: "",
        link: "/transaction_reports",
        title: "Transaction Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      // {
      //   icon: "",
      //   link: "//transaction_reports",
      //   title: "Transaction Report",
      //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
      // },
      // {
      //   icon: "",
      //   link: "//settlement_reports",
      //   title: "Settlement Report",
      //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
      // },
      // {
      //   icon: "",
      //   link: "/escrow-transactions",
      //   title: "Live Escrow Statement",
      // },
    ],
  },
  {
    icon: <Icon src={IconGenerateReport} width="21px" alt="report" />,
    link: "/",
    title: "Generate Report",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.GENERATE_REPORT],
    expanded: false,
    active: false,
  },
  // {
  //   icon: <Icon src={IconSend} width="21px" alt="notification" />,
  //   link: "/send-notification",
  //   title: "Send Notifications",
  //   id: "TNC",
  //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
  //   active: true,
  //   expanded: false,
  // },
  {
    icon: <Icon src={IconSend} width="21px" alt="notification" />,
    link: "/manage-notification",
    title: "Manage Notification",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.SEND_NOTIFICATION, PERMISSIONS.LIST_NOTIFICATION],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/list-notification",
        title: "Notification List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.LIST_NOTIFICATION],
      },
      {
        icon: "",
        link: "/send-notification",
        title: "Send Notifications",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.SEND_NOTIFICATION],
      },
      {
        icon: "",
        link: "/banner/list",
        title: "Banner",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.LIST_NOTIFICATION],
      },
    ],
  },
  {
    icon: <Icon src={IconTicket} width="21px" alt="ticket" />,
    link: "/manage-tickets",
    title: "Ticket Management",
    id: "ADMIN_TICKET_CREATE",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TICKET_MANAGEMENT],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconHelp} width="21px" alt="help" />,
    link: "/support",
    title: "Help & Support",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.HELP_SUPPORT],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconOperator} width="21px" alt="operator" />,
    link: "/manage-operators",
    title: "Manage Operator",
    id: "CREATE_OPERATOR",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_OPERATOR],
    expanded: false,
    active: true,
  },
  // {
  //   icon: <Icon src={IconQr} width="21px" alt="qr" />,
  //   link: "/qr-generate",
  //   title: "QR Generate",
  //   id: "TNC",
  //   expanded: false,
  //   active: true,
  // },
  // {
  //   icon: <Icon src={IconOperator} width="21px" alt="operator" />,
  //   link: "/manage-banner",
  //   title: "Manage Banner",
  //   id: "TNC",
  //   expanded: false,
  //   active: true,
  // },
  {
    icon: <Icon src={IconLoginJostory} width="21px" alt="operator" />,
    link: "/login-history",
    title: "Login History",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.LOGIN_HISTORY],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconChnagePaas} width="21px" alt="operator" />,
    link: "/change-password",
    title: "Change Password",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CHANGE_PASSWORD],
    expanded: false,
    active: true,
  },
  {
    icon: <Icon src={IconOperator} width="21px" alt="operator" />,
    link: "/reconcile-collect",
    title: "Reconcile Collect",
    id: "TNC",
    permissions: [PERMISSIONS.RECONCILE_APPROVAL_USER_LIST, PERMISSIONS.RECONCILE_REQUEST_LIST],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/reconcile/approval-user-list",
        title: "Approval User List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.RECONCILE_APPROVAL_USER_LIST],
      },
      {
        icon: "",
        link: "/reconcile/request-list",
        title: "Request List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.RECONCILE_REQUEST_LIST],
      },
    ],
  },
  {
    icon: <Icon src={IconPayBack} width="21px" alt="operator" />,
    link: "/payback",
    title: "Manage Payback",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_PAYBACK,
      PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST,
      PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST,
    ],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/payback",
        title: "Payback",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK],
      },
      {
        icon: "",
        link: "/payback/approval-user-list",
        title: "Approval User List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST],
      },
      {
        icon: "",
        link: "/payback/request-list",
        title: "Request List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST],
      },
    ],
  },
  {
    icon: <SecurityIcon style={{ fontSize: 21 }} />,
    link: "/permission-management",
    title: "Access Management",
    id: "AM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.PERMISSION_MANAGEMENT, PERMISSIONS.ROLE_MANAGEMENT],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/permission-management",
        title: "Permission Management",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      },
      {
        icon: "",
        link: "/role-management",
        title: "Role Manangement",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      },
    ],
  },
  {
    icon: <GroupsIcon style={{ fontSize: 21 }} />,
    link: "/society-partner-hub",
    title: "Organization Hub",
    id: "SP",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.ORGANIZATION_HUB],
    expanded: false,

    active: true,
    subNav: [
      // {
      //   icon: "",
      //   link: "/permission-management",
      //   title: "Permission Management",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      // },
      // {
      //   icon: "",
      //   link: "/role-management",
      //   title: "Role Manangement",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      // },
    ],
  },
  {
    icon: <ListAltIcon style={{ fontSize: 21 }} />,
    link: "/cpv-listing",
    title: "CPV Listing",
    id: "CPV",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CPV_LISTING],
    expanded: false,

    active: true,
    subNav: [
      // {
      //   icon: "",
      //   link: "/permission-management",
      //   title: "Permission Management",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      // },
      // {
      //   icon: "",
      //   link: "/role-management",
      //   title: "Role Manangement",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      // },
    ],
  },
  {
    icon: <CreditCardIcon style={{ fontSize: 21 }} />,
    link: "/card-management",
    title: "Card Management",
    id: "CAM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CARD_MANAGEMENT, PERMISSIONS.ORG_CARD_MANAGEMENT],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/card-management",
        title: "Card Product Management",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.CARD_MANAGEMENT],
      },
      {
        icon: "",
        link: "/org-card-management",
        title: "Org Card Product Manangement",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.ORG_CARD_MANAGEMENT],
      },
    ],
  },
  {
    icon: <InventoryIcon style={{ fontSize: 21 }} />,
    link: "/inventory-management",
    title: "Inventory Management",
    id: "IM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.QR_INVENTORY, PERMISSIONS.SOUNDBOX_INVENTORY, PERMISSIONS.QR_REQUEST],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/inventory-management/QR-code-inventory",
        title: "VPA Inventory",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.QR_INVENTORY],
      },
      {
        icon: "",
        link: "/inventory-management/soundbox-inventory",
        title: "Soundbox Inventory",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.SOUNDBOX_INVENTORY],
      },
      {
        icon: "",
        link: "/inventory-management/QR-request",
        title: "QR Request",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.QR_REQUEST],
      },
    ],
  },
];
